export default __webpack_public_path__ + "static/media/Apollo-Kullanim-Kilavuzu-Ys.ff23fef3.pdf";